import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  HostListener
} from '@angular/core';
import { ActiveSidePanelService } from '../active-side-panel.service';

@Component({
  selector: 'app-side-panel-wrapper',
  templateUrl: './side-panel-wrapper.component.html',
  styleUrls: ['./side-panel-wrapper.component.scss']
})
export class SidePanelWrapperComponent implements OnInit {

  @ViewChild('sidePanelTarget', { read: ViewContainerRef, static: true })
  sidePanelTarget: ViewContainerRef;

  @HostListener('document:keydown.escape', ['$event'])
  handleEscKeyEvent(event: KeyboardEvent) {
    this.activePanel.close();
  }

  constructor(private activePanel: ActiveSidePanelService) {}

  ngOnInit() {}
}
